import { Repository } from "../../adapters/repository";
import { isGroupValid } from "../../entities/groupValidator";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ namespace, group }) =>
    present(
      isGroupValid(group)
        ? repository
            .saveResourceGroup(namespace, group)
            .then((group) => ({ namespace, group }))
            .catch(() =>
              Promise.reject({
                namespace,
                group,
              }),
            )
        : Promise.reject({
            namespace,
            group,
          }),
    );
}

export type { Interactor };

export { createInteractor };
